/** @jsx jsx */

import { jsx } from '@emotion/react';
import { Box, Grid, Stack, xcss } from '@atlaskit/primitives';
import { N20A } from '@atlaskit/theme/colors';
import AvatarSlot from './slots/avatar-slot';
import ContentSlot from './slots/content-slot';
var inlineCommentStyles = xcss({
  gridTemplateAreas: "\n  \"avatar-area comment-area\"\n  \"nested-comments-area nested-comments-area\""
});
var containerStyles = xcss({
  position: 'relative',
  gridTemplateColumns: 'auto 1fr',
  gridTemplateAreas: "\"avatar-area comment-area\"     \". nested-comments-area\""
});

// if the background is appied on Box and tokens are not switched on it breaks.
// This can be safely removed (and applied on Box) when tokens are on by default
var highlightOverlayStyles = xcss({
  padding: 'space.100',
  position: 'absolute',
  // @ts-expect-error needs negative tokens
  inset: "var(--ds-space-negative-100, -8px)",
  // @ts-expect-error needs background-color to be on new theme
  backgroundColor: "var(--ds-background-neutral, ".concat(N20A, ")"),
  gridArea: '1 / 1 / 2 / 3',
  pointerEvents: 'none'
});
var stackOverrideStyles = xcss({
  paddingTop: 'space.300',
  gridArea: 'nested-comments-area'
});
/**
 * __CommentLayout__
 *
 * The base layout for the comment component.
 *
 */
var Layout = function Layout(_ref) {
  var content = _ref.content,
    children = _ref.children,
    highlighted = _ref.highlighted,
    id = _ref.id,
    shouldRenderNestedCommentsInline = _ref.shouldRenderNestedCommentsInline,
    testId = _ref.testId,
    avatar = _ref.avatar;
  return jsx(Grid, {
    gap: "space.100",
    templateAreas: !children ? ['avatar-area comment-area'] : undefined,
    xcss: [containerStyles, shouldRenderNestedCommentsInline && inlineCommentStyles],
    testId: testId,
    id: id
  }, avatar && jsx(AvatarSlot, null, avatar), content && jsx(ContentSlot, null, content), children && jsx(Stack, {
    xcss: stackOverrideStyles,
    space: "space.400"
  }, children), highlighted && jsx(Box, {
    xcss: highlightOverlayStyles,
    testId: testId && "".concat(testId, "-highlighted")
  }));
};
Layout.displayName = 'CommentLayout';
export default Layout;